<template>
  <div class="market-card">
    <header class="card_header">
      <div class="card-pricing">
        <span class="text-white"
          ><img
            :src="getImage(item.price)"
            alt="wax"
            class="img-fluid wax-logo"
          />
          <span class="mx-2 card_price">{{ item.price }}</span>
        </span>
      </div>
      <button class="info_btn" @click="cardInfo(selectedInfo)">
        <i class="bi bi-info"></i>
      </button>
    </header>

    <section class="card-info" v-if="selectedInfo">
      <ul class="p-0">
        <li>
          title <span>{{ getTitle(item.schema) }}</span>
        </li>
        <li>
          Price <span>{{ item.price }}</span>
        </li>
        <li
          v-if="
            item.schema == 'FSTEW' ||
            item.schema == 'BEANS' ||
            item.schema == 'CBREAD' ||
            item.schema == 'JERKY'
          "
        >
          Health Recovery <span>{{ getHealthRecovery(item.schema) }}%</span>
        </li>
      </ul>
    </section>

    <section class="card_img" v-else>
      <ImgBlock
        :img="`/images/gameitem/${item.schema}.png`"
        :link="false"
        :defaultLink="`/images/${item.schema}`.gif"
      />
    </section>

    <section
      class="card-content fw-bold text-center"
      :class="selectedInfo === 'card-info-list' ? 'hideContent' : ''"
    >
      <p>
        Supply {{ item.supply }} /
        {{ Number(item.supply) - Number(item.total_sale) }}
      </p>
    </section>
    <footer class="card_footer mt-3">
      <div class="qty-input">
        <input
          type="number"
          class="form-control"
          placeholder="Quantity"
          v-model="qty"
        />
      </div>
      <button @click="buy(item.asset_t, item.price)" class="btn btn-rounded">
        buy
      </button>
    </footer>
  </div>
</template>
<script>
import ApiService from "../services";
import "vue-loading-overlay/dist/vue-loading.css";
import ImgBlock from "../components/ImgBlock.vue";
export default {
  name: "MarketItem",
  props: ["item"],
    components: {
    ImgBlock
  },
  data() {
    return {
      selectedInfo: false,
      qty: "",
      openFiltersList: false,
      isLoading: true,
      waxLoaded: false,
      searchTerm: "",
      isImageLoaded: false,
      gameItems: false,
      rarity: "all",
    };
  },
  methods: {
    loaded() {
      this.isImageLoaded = true;
    },

    async buy(templateId, price) {
      if (price && this.qty > 0) {
        let finalPrice = ApiService.calculateCur(price, this.qty);
        let currencyWax = price.includes("WAX");
        let data = ApiService.buyDataMarket(currencyWax,finalPrice,templateId,this.qty);
        await ApiService.transaction(data, (response) => {
          if (response.processed) {
            ApiService.successMsg("Purchase Successfull");
            ApiService.getHeaderContents();
            this.$emit("refresh", []);
          }
        });
      } else {
        ApiService.errorMsg("Input quantity must be greater than 0");
      }
    },
    cardInfo(selected) {
      this.selectedInfo = !selected;
    },
    getImage(price){
      if(price.includes("WAX")){
        return "/images/wax-logo.png";
      }else if(price.includes("WWS")){
        return "/images/scoin.png";
      }
      return "/images/gcoin.png";
    },
    getTitle(schema) {
      console.log(schema);
      if(!this.gameItems) {
        this.gameItems=ApiService.gameItemList();
      }
      return this.gameItems[schema];
    },
    getHealthRecovery(schema) {
      switch (schema) {
        case "FSTEW":
          return 100;
        case "CBREAD":
          return 50;
        case "BEANS":
          return 25;
        case "JERKY":
          return 75;
        default:
          return 0;
      }
    },
  },
};
</script>

<style scoped>
.card_img img {
  aspect-ratio: 3/2;
  object-fit: contain;
  width: 100%;
}
</style>
